// Client-side helpers over a form definition served by
// GET /assessments/schema/<code>. These mirror is_visible / missing_required /
// progress in wmfapproot/services/assessment_schemas.py so the form can show
// what is missing without a round trip; the server remains the authority.

export function isBlank(value) {
  return value === null || value === undefined || value === ''
    || (Array.isArray(value) && value.length === 0)
    || (typeof value === 'string' && !value.trim());
}

export function isVisible(field, values) {
  const cond = field.showIf;
  if (!cond) return true;
  const current = values[cond.key];
  if ('includes' in cond) return Array.isArray(current) && current.includes(cond.includes);
  return current === cond.equals;
}

export function sectionFields(section) {
  return section.fields || [];
}

export function missingInSection(section, values) {
  return sectionFields(section)
    .filter((f) => f.required && isVisible(f, values) && isBlank(values[f.key]))
    .map((f) => f.key);
}

export function missingRequired(schema, values, kind = 'form') {
  return schema.sections
    .filter((s) => (kind === 'memo' ? s.kind === 'memo' : s.kind !== 'memo'))
    .flatMap((s) => missingInSection(s, values));
}

export function sectionProgress(section, values) {
  const fields = sectionFields(section).filter((f) => isVisible(f, values));
  return {
    answered: fields.filter((f) => !isBlank(values[f.key])).length,
    total: fields.length,
    missing: missingInSection(section, values).length,
  };
}

export function fieldLabel(schema, key) {
  for (const s of schema.sections) {
    const f = s.fields.find((x) => x.key === key);
    if (f) return { label: f.label, sectionId: s.id, sectionTitle: s.title };
  }
  return { label: key, sectionId: null, sectionTitle: null };
}

export function fieldDomId(key) {
  return `field-${key.replace(/[^A-Za-z0-9_-]/g, '-')}`;
}

export function sectionDomId(id) {
  return `section-${id}`;
}
